import { createSvgIcon } from "@mui/material";

export const Icon = createSvgIcon(
  <>
    <path
      id="Vector"
      d="M15 14.58C14.48 15.96 13.51 16.67 12.12 16.67C9.87004 16.67 9.54004 15.16 9.51004 13.69V13.57L9.86004 13.54C11.29 13.42 13.68 13.23 15.57 12.43C17.63 11.58 18.62 10.25 18.62 8.36001C18.62 6.89001 17.96 4.42001 13.54 4.42001C8.61004 4.42001 5.29004 8.01001 5.29004 13.35C5.29004 15.69 6.09004 19.63 11.43 19.63C14.76 19.63 17.21 18.07 18.16 15.35L18.43 14.58H15ZM9.68004 10.91C9.98004 8.57001 11.31 7.12001 13.17 7.12001C14.53 7.12001 14.81 7.89001 14.81 8.54001C14.81 9.55001 14.17 10.21 12.81 10.6C11.63 10.96 10.22 11.04 9.81004 11.06H9.65004L9.67004 10.91H9.68004Z"
    />
  </>,
  "Loan",
);

export default Icon;
